module.exports = __webpack_public_path__ + "static/OldMansJourney1-86421034e9d6642028290c9e6a6d0a14.png";